import React, { memo } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import config from '../../config';
import { sendContactForm } from '../../ducks/contact.duck';
import ContactForm from '../../forms/ContactForm/ContactForm';
import useAppSelector from '../../util/hooks/useAppSelector';
import Modal from '../ModalNew/Modal';
import ContactSuccess from './ContactSuccess';

/**
 * ContactModal is a modal that displays a contact form.
 * @param {object} props
 * @param {boolean} props.isOpen - whether the modal is open
 * @param {Function} props.onClose - function to close the modal
 */
const ContactModalComponent = ({ isOpen, onClose }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  // `sendContactForm` swallows a failed request and resolves either way, so the
  // confirmation hangs off the store flag the success action sets — never off
  // the submit promise settling.
  const contactFormSent = useAppSelector((state) => state.contact.contactFormSent);

  const title = intl.formatMessage({
    id: contactFormSent ? 'ContactModal.successTitle' : 'ContactModal.title',
  });

  const handleSubmit = async (values) => {
    await dispatch(sendContactForm(values));
  };

  return (
    <Modal actions={[]} onClose={onClose} open={isOpen} title={title}>
      {contactFormSent ? (
        <ContactSuccess onClose={onClose} />
      ) : (
        <GoogleReCaptchaProvider
          container={{
            element: 'ContactForm',
            parameters: { badge: 'inline' },
          }}
          language={intl.locale}
          reCaptchaKey={config.google.recaptcha}
        >
          <ContactForm onSubmit={handleSubmit} />
        </GoogleReCaptchaProvider>
      )}
    </Modal>
  );
};

ContactModalComponent.displayName = 'ContactModal';

const ContactModal = memo(ContactModalComponent);

export default ContactModal;
